appConfig.getModule()
    .constant('AUTH_EVENTS', {
        loginSuccess: 'auth-login-success',
        loginFailed: 'auth-login-failed',
        logoutSuccess: 'auth-logout-success',
        sessionTimeout: 'auth-session-timeout',
        notAuthenticated: 'auth-not-authenticated',
        notAuthorized: 'auth-not-authorized',
        setCurrentUser: 'set-current-user'
    })
    .constant('SERVICE_CALL', {
        system: {
            getSessionDetails: 163,
            saveSysConfigs: 216,
            getSysConfigs: 217,
            getUserPreferenceDetails:218
        },
        dashboardMgt: {
            getDashboardList: 110,
            getDashboardDetails: 168,
            deleteDashboard: 116,
            createDashboardCopy: 141,
            getAreaList: 118,
            getAllAreaList: 213,
            generateProfile: 214,
            getConnectionDetails: 215,
            getListOfVisualizations: 108,
            getSectionDetails: 143,
            getDashboardSectionDetails: 221,
            addSectionDetails: 144,
            deleteSection: 145,
            updateSectionDetails: 146,
            getDashboardTemplate: 111,
            addVisualization: 106,
            addGalleryVisualization: 404,
            // copyVisualization : 99,
            deleteVisualizationObj: 115,
            getIndicatorList: 105,
            getSubgroups: 109,
            getAllSubgroups: 200,
            dashboardConnectionSave: 170,
            searchArea: 133,
            searchIC: 802,
            setGridsterTemplate: 112,
            setVisualizationObjectIsUsed: 113,
            saveVisualization: 107,
            getDashboardName: 167,
            checkDuplicatedashboardUrl: 142,
            importFile: 171,
            getMediaFilesList: 147,
            getSectionsList: 143,
            getVisualizationObjectData: 117,
            getLanguageList: 150,
            getICList: 151,
            getICName: 152,
            getICNameListByGid: 401,
            getIUNameListByGid: 402,
            getIUSNameListByGid:403,
            getPublishedDashboardId: 172,
            getVisualizationDetails: 122,
            getSelectedAreaDetails: 128,
            checkOwner: 123,
            setVisAnalysis: 124,
            getVisAnalysis: 125,
            getIUSList: 300,
            getIUSListFromIU: 301,
            getIUSListFromGid: 302,
            getTimePeriodList: 303,
            getVisObjDBDimension: 220,
            getUnitList: 230,            
            excelExportViz: 225,
            deleteServerUploads: 226,
            loadImageData: 600,
            saveHeaderFooter: 229,
            getHeaderFooterList: 223,
            getHeaderFooterDetails: 224,
            deleteHeaderFooter : 227,
            createHeaderFooterCopy : 228,
            copyVisualization: 222,
        },
        database: {
            getDatabaseList: 101,
            deleteDatabase: 121,
            testDatabaseConnection: 120,
            getConnectionDetails: 169,
            editAsDatabaseConnection: 166
        },
        mediaFiles: {
            importFile: 171,
            getMediaFilesList: 147,
            deleteMedia: 164,
            isMediaFileExist: 205
        },
        publish: {
            updateDashboardDetails: 104,
            LanguageList: 150,
            exportFile: 153,
            importFile: 154,
            copyPublishDashboard: 141,
            savePrivateDashUser: 406,
            deletePrivateDashUser: 407
        },
        translations: {
            getLanguageList: 155,
            deleteLanguageKey: 156,
            getLanguageKeys: 157,
            getTranslationDetails: 158,
            saveTranslation: 159,
            compileLanguage: 160,
            importFile: 2441,
            getExportUrl: 2442,
            getTranslationStrings: 162,
            getDefaultLanguage: 161
        },
        explore: {
            getMetadata: 129
        },
        userMgmt: {
            getUserList: 201,
            getUserDetails: 202,
            deleteUser: 203,
            addEditUser: 204,
            forgotPassword: 206,
            confirmPassword: 207,
            changePassword:219,
        },
        transactionLogs:{            
            getTransactionLogsList: 405 ,
        },
        userGallery: {
            saveVisualization: 208,
            getUserItems: 209,
            deleteGalleryItem: 210,
            copyGalleryItem: 211,
            searchGalleryItems: 212
        },
        dfaVersion:{
            versionApi : 'version',
            changeLogApi : 'changelog',
            readMeApi : 'readme'
        },
    })
    .constant('PAGINATION_DEFAULT', {
        pageSize: 10,
        currentPage: 1,
        from: 1,
        to: 10,
        totalCount: '',
        pageSizes: [10, 20, 30, 40, 50]
    })
    .constant('MODULES', {})
    .constant('FONT_SIZE', [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100])
    .constant('FONT_FAMILY', ['Arial', 'Times New Roman', 'Verdana', 'Courier', 'Georgia', 'Comic Sans MS', 'Palatino Linotype',
        'Impact', 'Tahoma', 'Monaco', 'Courier New', 'Lucida Console', 'Lucida Sans Unicode'])
    .constant('ACTIONS', {
        C: 'create',
        R: 'view',
        U: 'update',
        D: 'delete',
        E: 'export',
        I: 'import'
    })
    .constant('MODE', {
        "edit": "edit",
        "publish": "publish"
    })
    .constant('DB_TYPE', {
        "Mysql": "Mysql",
        "Sqlserver": "Sqlserver"
    })
    .constant('ACCESS_TYPE', {
        "Query": "Query",
        "API": "API"
    })
    .constant('DI_TYPE', {
        "DI7": "Devinfo"
    })
    .constant('DEFAULT_PORT', {
        "Mysql": "3306",
        "Sqlserver": "1433"
    })
    .constant('CONNECTION_TYPE', {
        "DI7": "Connect to DevInfo Database",
        "WorldBankAPI": "Connect to World Bank API",
        "UNDataAPI": "Connect to UN Data API"
    })
    .constant('SORT_ORDER_TYPE', {
        "asc": true,
        "desc": false,
        "none": ""
    })
    .constant('RESOLUTION', {
        "1024px": "Width = 1024px",
        "100%": "Width = 100%"
    })
    .constant('MEDIA_FILES', {
        "mediaFile": ""
    })
    .constant('GRIDSTACK_OPTIONS', {
        cellHeight: 10,
        cellWidth: 10,
        verticalMargin: 4
    })
    .constant('LANG_SELECTED', {
        "en": "en",
        "la": "la"
    })
    .constant('VISUALIZATION_TYPE_OPTIONS', {
        line: {
            "title": "Line charts",
            "name": "line",
            "faicon": "fa-line-chart",
            "chartType": {
                line: {
                    "title": "Line chart",
                    "categoryName": "line",
                    "name": "line",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "line"
                        }
                    }
                }, spline: {
                    "title": "Spline",
                    "categoryName": "line",
                    "name": "spline",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "spline"
                        }
                    }
                }, polarline: {
                    "title": "Polar line",
                    "categoryName": "line",
                    "name": "polarline",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "line",
                            "polar": true
                        }
                    }
                }, spiderweb: {
                    "title": "Spiderweb",
                    "categoryName": "line",
                    "name": "spiderweb",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "line",
                            "polar": true
                        },
                        "xAxis": {
                            "tickmarkPlacement": "on",
                            "lineWidth": 0
                        },
                        "yAxis": {
                            "lineWidth": 0,
                            "gridLineInterpolation": "polygon"
                        }
                    }
                }
            }
        },
        area: {
            "title": "Area charts",
            "name": "area",
            "faicon": "fa-area-chart",
            "chartType": {
                basic: {
                    "title": "basic",
                    "categoryName": "area",
                    "name": "basic",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "area"
                        }
                    }
                },
                stacked: {
                    "title": "Stacked",
                    "categoryName": "area",
                    "name": "stacked",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "area"
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "normal"
                            }
                        }
                    }
                },
                stackedpercent: {
                    "title": "Stacked percent",
                    "categoryName": "area",
                    "name": "stackedpercent",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "area"
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "percent"
                            }
                        }
                    }
                }
            }
        },
        columnbar: {
            "title": "Column/Bar",
            "name": "columnbar",
            "faicon": "fa-bar-chart",
            "chartType": {
                groupedcolumn: {
                    "title": "Grouped column",
                    "categoryName": "columnbar",
                    "name": "groupedcolumn",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column"
                        },
                        "plotOptions": {
                            "column": {
                                "minPointLength": 2
                            }
                        }
                    }
                },
                stacked: {
                    "title": "Stacked",
                    "categoryName": "columnbar",
                    "name": "stacked",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column"
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "normal"
                            },
                            "column": {
                                "minPointLength": 2
                            }
                        }
                    }
                },
                stackedpercent: {
                    "title": "Stacked percent",
                    "categoryName": "columnbar",
                    "name": "stackedpercent",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column"
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "percent"
                            },
                            "column": {
                                "minPointLength": 2
                            }
                        }
                    }
                },
                basicbar: {
                    "title": "Basic bar",
                    "categoryName": "columnbar",
                    "name": "basicbar",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column",
                            "inverted": true
                        },
                        "plotOptions": {
                            "column": {
                                "minPointLength": 2
                            }
                        }
                    }
                },
                stackedbar: {
                    "title": "Stacked bar",
                    "categoryName": "columnbar",
                    "name": "stackedbar",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column",
                            "inverted": true
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "normal"
                            },
                            "column": {
                                "minPointLength": 2
                            }
                        }
                    }
                },
                stackedpercentbar: {
                    "title": "Stacked percent bar",
                    "categoryName": "columnbar",
                    "name": "stackedpercentbar",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column",
                            "inverted": true
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "percent"
                            },
                            "column": {
                                "minPointLength": 2
                            }
                        }
                    }
                }
            }
        },
        agepyramid: {
            "title": "Pyramid",
            "name": "agepyramid",
            "faicon": "fa-diamond",
            //"faimg": "img/faicons/pyramid.png",
            "chartType": {
                agepyramid: {
                    "title": "Age Pyramid",
                    "categoryName": "agepyramid",
                    "name": "agepyramid",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "column",
                            "inverted": true
                        },
                        "plotOptions": {
                            "series": {
                                "stacking": "normal"
                            }
                        }
                    }
                }
            }
        },
        scatter: {
            title: "Scatter",
            name: "scatter",
            "faicon": "fa-dot-circle-o",
            //"faimg": "img/faicons/pyramid.png",
            chartType: {
                scatter: {
                    "title": 'Scatter',
                    "categoryName": 'scatter',
                    "name": 'scatter',
                    "provider": 'highcharts',
                    "config": {
                        "chart": {
                            type: 'scatter'
                        }
                    }
                }
            }
        },
        pie: {
            "title": "Pie charts",
            "name": "pie",
            "faicon": "fa-pie-chart",
            "chartType": {
                pie: {
                    "title": "Pie charts",
                    "categoryName": "pie",
                    "name": "pie",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "pie"
                        },
                        "plotOptions": {
                            "pie": {
                                "allowPointSelect": true,
                                "cursor": true,
                                "dataLabels": {
                                    "distance": 8
                                }
                            },
                            "series": {
                                "dataLabels": {
                                    "enabled": true
                                }
                            }
                        }
                    }
                },
                donut: {
                    "title": "Donut",
                    "categoryName": "pie",
                    "name": "donut",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "pie"
                        },
                        "plotOptions": {
                            "pie": {
                                "allowPointSelect": true,
                                "cursor": true,
                                "showInLegend": true,
                                "innerSize": "60%"
                            }
                        }
                    }
                },
                semidonut: {
                    "title": "Semi Donut",
                    "categoryName": "pie",
                    "name": "semidonut",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "pie"
                        },
                        "plotOptions": {
                            "pie": {
                                "allowPointSelect": false,
                                "dataLabels": {
                                    "distance": -30,
                                    "style": {
                                        "fontWeight": "bold",
                                        "color": "white",
                                        "textShadow": "0px 1px 2px black"
                                    }
                                },
                                "innerSize": "50%",
                                "startAngle": -90,
                                "endAngle": 90,
                                "center": ["50%", "75%"]
                            },
                            "series": {
                                "dataLabels": {
                                    "enabled": true
                                }
                            }
                        }
                    }
                }
            }
        },
        maps: {
            "title": "Maps",
            "name": "maps",
            "faicon": "fa-globe",
            //"faimg": "img/faicons/map.png",
            "chartType": {
                mapwithsingleius: {
                    "title": "Map",
                    "categoryName": "maps",
                    "name": "mapwithsingleius",
                    "provider": "highmaps",
                    "urlImg": "img/line-chrt1.png",
                    "config": {}
                },
                /*mapwithmultipleius: {
                    "title": "Map with Multiple IUS",
                    "categoryName": "maps",
                    "name": "mapwithmultipleius",
                    "provider": "highmaps",
                    "urlImg": "img/line-chrt1.png",
                    "config": {}
                }*/
            }
        },
        custom: {
            "title": "Custom",
            "name": "custom",
            "faicon": "fa-code",
            "chartType": {
                html: { // become tile now
                    "title": "HTML",
                    "categoryName": "HTML",
                    "name": "html",
                    "provider": "custom",
                    "urlImg": "",
                    "config": {}
                },
                tile: {
                    "title": "Tile",
                    "categoryName": "HTML",
                    "name": "tile",
                    "provider": "custom",
                    "urlImg": "",
                    "faicon":"id-card-o",
                    "config": {}
                },
                text: {
                    "title": "Text",
                    "categoryName": "HTML",
                    "name": "text",
                    "provider": "custom",
                    "urlImg": "",
                    "faicon":"id-card-o",
                    "config": {}
                },
                image: {
                    "title": "Image",
                    "categoryName": "HTML",
                    "name": "image",
                    "provider": "custom",
                    "urlImg": "",
                    "faicon":"id-card-o",
                    "config": {}
                },
                video: {
                    "title": "Video",
                    "categoryName": "HTML",
                    "name": "video",
                    "provider": "custom",
                    "urlImg": "",
                    "faicon":"id-card-o",
                    "config": {}
                },
                // profileDownload: {                  
                //     "title": "Profile Downloader",
                //     "categoryName": 'profile',
                //     "name": "profile",
                //     "provider": "profile",
                //     "urlImg": "img/profile.png",
                //     "config": {}
                // },
                // slider: {   // Slider is a part of custom Visualisation Type
                //     "title": "slider",
                //     "categoryName": "slider",
                //     "name": "slider",
                //     "provider": "custom",
                //     "urlImg": "",
                //     "config": {}
                // }
            }
        },
        table: {                                   //table-hidden
            "title": "Table",
            "name": "table",
            "faicon": "fa-table",
            "chartType": {
                // table: {
                //     "title": "TABLE",
                //     "categoryName": 'table',
                //     "name": "table",
                //     "provider": "custom",
                // },
                // grid: {
                //     "title": "DFA TABLE",
                //     "categoryName": 'table',
                //     "name": "grid",
                //     "provider": "custom"
                // },
                DataTable: {
                    "title": "DATA TABLE",
                    "categoryName": 'table',
                    "name": "dataTable",
                    "provider": "custom",
                    "faicon":"fa-table",
                }
            }
        },
        treemap: {
            "title": "Tree Map",
            "name": "treemap",
            "faicon": "fa-tree",
            "chartType": {
                "sunburst": {
                    "provider": "d3",
                    "title": "Sunburst",
                    "categoryName": "treemap",
                    "name": "sunburst"
                },
                "treemap_squarified": {
                    "title": "Treemap - Squares",
                    "categoryName": "treemap",
                    "provider": "highcharts",
                    "name": "treemap_squarified",
                    "config": {
                        "chart": {
                            "type": "treemap"
                        },
                        "plotOptions": {
                            "treemap": {
                                "layoutAlgorithm": "squarified"
                            }
                        }
                    }
                },
                "treemap_splice_dice": {
                    "title": "Treemap - Splice n Dice",
                    "categoryName": "treemap",
                    "provider": "highcharts",
                    "name": "treemap_splice_dice",
                    "config": {
                        "chart": {
                            "type": "treemap"
                        },
                        "plotOptions": {
                            "treemap": {
                                "layoutAlgorithm": "sliceAndDice"
                            }
                        }
                    }
                },
                "treemap_stripes": {
                    "title": "Treemap - Stripes",
                    "categoryName": "treemap",
                    "provider": "highcharts",
                    "name": "treemap_stripes",
                    "config": {
                        "chart": {
                            "type": "treemap"
                        },
                        "plotOptions": {
                            "treemap": {
                                "layoutAlgorithm": "stripes"
                            }
                        }
                    }
                }
            }
        },
        "percentageChart": {
            "title": "Percentage Charts",
            "name": "percentageCharts",
            "faicon": "fa-percent",
            "chartType": {
                "dfaDotMatrix": {
                    "provider": "d3",
                    "title": "DFA Dot Matrix",
                    "categoryName": "dfaDotMatrix",
                    "name": "dfaDotMatrix"
                },
                "100minus": {
                    "title": "100 Minus",
                    "categoryName": "percentageChart",
                    "name": "100minus",
                    "provider": "highcharts",
                    "config": {
                        "chart": {
                            "type": "pie"
                        },
                        "plotOptions": {
                            "pie": {
                                "dataLabels": {
                                    "enabled": false
                                }
                            }
                        },
                        "tooltip": {
                            "enabled": false
                        }
                    }
                }
            }
        }
    })

    .constant('ADD_MODIFY_VIS_CONFIG', {
        "highcharts": {
            //sections: [0, 1, 2, 8],
            sections: [10, 11, 12, 13, 14, 15],
            customizeOptions: [0, 1, 2, 3, 4, 5, 21, 6, 7, 8, 17],
            settingOptions: [2, 4], // hide Event and Explore [0, 1, 2, 4],
            treemap: {
                sections: [10, 11, 15], // added in v3
                customizeOptions: [0, 1, 16]
            },
            pie: {
                '100minus': {
                    sections: [10, 11, 12, 13, 14, 15], // adding in v3
                    customizeOptions: [0, 1, 4, 5, 6]
                }
            },
            previewSections: [17, 11, 12, 13, 14], // preview section
            addVisPreview:[17,10, 11, 12, 13, 14],
        },
        "highmaps": {
            //sections: [0, 1, 2, 8],
            sections: [10, 18, 16, 15],
            customizeOptions: [9, 10, 11, 12, 13, 14, 17],
            settingOptions: [2, 4],            //0,1 are removed to hide event and explore
            previewSections: [17, 18, 16], // preview section
            addVisPreview:[17, 10, 18, 16]
        },
        "custom": {
            //sections: [0, 1, 4, 8],
            sections: [10, 19, 15],
            settingOptions: [2,4],
            HTML: {
                // it was empty here but now adding the below for handling tile feature
                //sections: [10, 21, 19],
                sections: [10, 21], // Used for Tile view
                html: {
                    sections: [10, 19, 15], // Html
                },
                text: {
                    sections: [21], // Text
                },
                image: {
                    sections: [21], // Image
                },
                video: {
                    sections: [21], // Video
                },
            },
            slider: {
                sections: [9], //[9, 1]
            },
            table: {
                table: {
                    //sections: [0, 1, 2, 8],
                    sections: [10, 12, 13, 15], 
                    customizeOptions: [4, 5]
                },
                grid: {
                    //sections: [0, 1, 2, 8],
                    sections: [10, 11, 14, 15],
                    settingOptions: [2,4],                    
                    customizeOptions: [20, 6, 19, 12, 18]
                },
                dataTable: {
                    sections: [10,22,14,15],
                    addVisPreview: [10,14,22]
                }
            }
        },
        "d3": {
            //sections: [0, 1, 2, 3, 8],
            sections: [10, 11, 15],
            customizeOptions: [15, 16],
            settingOptions: [1, 2],
            "dfaDotMatrix": {
                "dfaDotMatrix": {
                    sections: [10, 11, 20, 15],
                    customizeOptions: [22, 23, 24, 25],
                    addVisPreview:[17,10, 11, 20, 15]
                }
            }
        },

        "selectList": {
            sections: [5, 8],
            settingOptions: [2]
        },
        "globalSelectList": {
            sections: [6, 8],
            settingOptions: [2]
        },
        "profile": {
            sections: [7, 8], //[7, 1, 8],
            settingOptions: [2]
        }
    })

    .constant('SECTION_OPTIONS', [{
        name: 'CONFIGURE', // 0
        templateUrl: 'js/app/components/design/views/configureDataVisualization.html'
        //templateUrl: 'js/app/components/design/views/configureDataVisualizationV3.html'
    }, {
        name: 'VISUALIZATION_TYPE', // 1
        //templateUrl: 'js/app/components/design/views/visualizationType.html'
        templateUrl: 'js/app/components/design/views/visualizationTypeV3.html'
    }, {
        name: 'CUSTOMIZE', // 2
        templateUrl: 'js/app/components/design/views/customizeOptions.html'
    }, {
        name: 'EXPLORE', // 3
        templateUrl: 'js/app/components/design/views/exploreOption.html'
    }, {
        name: 'CUSTOMIZE_HTML', // 4
        templateUrl: 'js/app/components/design/views/customHTML.html'
    }, {
        name: 'CONFIGURE_SELECT_LIST', // 5
        //templateUrl: 'js/app/components/design/views/configureSelectListVisualization.html'
        templateUrl: 'js/app/components/design/views/configureSelectListVisualizationV3.html'
    }, {
        name: 'CONFIGURE_SELECT_LIST', // 6
        //templateUrl: 'js/app/components/design/views/configureGlobalSelectListVisualization.html'
        templateUrl: 'js/app/components/design/views/configureGlobalSelectListVisualizationV3.html'
    }, {
        name: 'PROFILE_DOWNLOADER', // 7
        //templateUrl: 'js/app/components/design/views/configureProfileDownloadVisualization.html'
        templateUrl: 'js/app/components/design/views/configureProfileDownloadVisualizationV3.html'
    }, {
        name: 'SETTING', // 8
        //templateUrl: 'js/app/components/design/views/settingOption.html'
        templateUrl: 'js/app/components/design/views/settingOptionV3.html'
    }, {
        name: 'SLIDER', // 9
        //templateUrl: 'js/app/components/design/views/slider.html'
        templateUrl: 'js/app/components/design/views/sliderV3.html'
    },{
        name: 'DATA', // 10 added in v3
        //templateUrl: 'js/app/components/design/views/configureDataVisualization.html'
        templateUrl: 'js/app/components/design/views/configureDataVisualizationV3.html'
    },{
        name: 'GENERAL', // 11 added in v3
        templateUrl: 'js/app/components/design/views/customizeOptions_GeneralV3.html'
    },{
        name: 'DATA_SERIES', // 12 added in v3
        templateUrl: 'js/app/components/design/views/customizeOptions_DataSeriesV3.html'
    },{
        name: 'CATEGORIES', // 13 added in v3
        templateUrl: 'js/app/components/design/views/customizeOptions_CategoriesV3.html'
    },{
        name: 'THEME', // 14 added in v3 for highcharts theme
        templateUrl: 'js/app/components/design/views/customizeOptions_ThemeHighchartsV3.html'
    }, {
        name: 'ADVANCE', // 15 added in v3
        templateUrl: 'js/app/components/design/views/settingOptionV3.html'
    },{
        name: 'THEME', // 16 added in v3 for map theme
        templateUrl: 'js/app/components/design/views/customizeOptions_ThemeMapsV3.html'
    },{
        name: 'ABOUT', // 17 added in v3 for user gallery
        templateUrl: 'js/app/components/preview/views/gallery_about.html'
    },{
        name: 'GENERAL', // 18 added in v3 for Map
        templateUrl: 'js/app/components/design/views/customizeOptions_GeneralMapsV3.html'
    }, {
        name: 'CUSTOMIZE_HTML', // 19 added in v3 for custom html
        templateUrl: 'js/app/components/design/views/customHTMLV3.html'
    },{
        name: 'DATA_SERIES', // 20 added in v3 for DotMatrix
        templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_dataSeriesV3.html'
    },{
        name: 'GENERAL', // 21 added in v4 - for custom tile
        templateUrl: 'js/app/components/design/views/tileOptions_General.html'
    },{
        name:'GENERAL', //22 added in v4-for DFA Table
        templateUrl:'js/app/components/design/views/customizeOptions_GeneralTables.html'
    }])

    .constant('SETTING_OPTIONS', [{
        name: 'EVENT',
        //templateUrl: 'js/app/components/design/views/settingOption_Events.html'
        templateUrl: 'js/app/components/design/views/settingOption_EventsV3.html'
    }, {
        name: 'EXPLORE',
        //templateUrl: 'js/app/components/design/views/exploreOption.html'
        templateUrl: 'js/app/components/design/views/exploreOptionV3.html'
    }, {
        name: 'DATABASE',
        //templateUrl: 'js/app/components/design/views/database.html'
        templateUrl: 'js/app/components/design/views/databaseV3.html'
    }, {
        name: 'SLIDER',
        //templateUrl: 'js/app/components/design/views/slider.html'
        templateUrl: 'js/app/components/design/views/sliderV3.html'
    }, {
        name: 'CONTEXT_MENU_OPTIONS',
        //templateUrl: 'js/app/components/design/views/context_menu_options.html'
        templateUrl: 'js/app/components/design/views/contextMenuOptionsV3.html'
    }])

    .constant('CUSTOMIZE_OPTIONS', [{ // 0
        name: 'GENERAL',
        templateUrl: 'js/app/components/design/views/customizeOptions_General.html'
    }, {
        name: 'APPEARANCE', // 1
        templateUrl: 'js/app/components/design/views/customizeOptions_Appearance.html'
    }, {
        name: 'AXES', // 2
        templateUrl: 'js/app/components/design/views/customizeOptions_Axes.html'
    }, {
        name: 'GRID_LINES', // 3
        templateUrl: 'js/app/components/design/views/customizeOptions_GridLines.html'
    }, {
        name: 'DATA_SERIES', // 4
        templateUrl: 'js/app/components/design/views/customizeOptions_DataSeries.html'
    }, {
        name: 'CATEGORIES', // 5
        templateUrl: 'js/app/components/design/views/customizeOptions_Categories.html'
    }, {
        name: 'VALUE_LABELS', // 6
        templateUrl: 'js/app/components/design/views/customizeOptions_ValueLabels.html'
    }, {
        name: 'LEGEND', // 7
        templateUrl: 'js/app/components/design/views/customizeOptions_Legend.html'
    }, {
        name: 'TICKS', // 8
        templateUrl: 'js/app/components/design/views/customizeOptions_Ticks.html'
    }, {
        name: 'GENERAL', // 9
        templateUrl: 'js/app/components/design/views/customizeOptions_GeneralMaps.html'
    }, {
        name: 'MAP_APPEAR', // 10
        templateUrl: 'js/app/components/design/views/customizeOptions_AppearanceMaps.html'
    }, {
        name: 'LABELS_MAP', // 11
        templateUrl: 'js/app/components/design/views/customizeOptions_LabelMaps.html'
    }, {
        name: 'THEME', // 12
        templateUrl: 'js/app/components/design/views/customizeOptions_ThemeMaps.html'
    }, {
        name: 'LEGEND_MAPS', // 13
        templateUrl: 'js/app/components/design/views/customizeOptions_LegendMaps.html'
    }, {
        name: 'NAVIGATION', // 14
        templateUrl: 'js/app/components/design/views/customizeOptions_NavigationMaps.html'
    }, {
        name: 'GENERAL', // 15
        templateUrl: 'js/app/components/design/views/customizeOptions_General.html'
    }, {
        name: 'LEVELS', // 16
        //templateUrl: 'js/app/components/design/views/customizeOptions_treemapLevels.html'
        templateUrl: 'js/app/components/design/views/customizeOptions_treemapLevelsV3.html'
    }, {
        name: 'Tooltip', // 17
        templateUrl: 'js/app/components/design/views/toolTip.html'
    }, {
        name: 'GRID_OPTIONS', // 18
        templateUrl: 'js/app/components/design/views/customizeOptions_gridOptions.html'
    }, {
        name: 'GRID_OPTIONS_APPEARANCE', // 19
        //templateUrl: 'js/app/components/design/views/customizeOptions_AppearanceGrid.html'
        templateUrl: 'js/app/components/design/views/customizeOptions_AppearanceGridV3.html'
    }, {
        name: 'GRID_GENERAL', // 20
        templateUrl: 'js/app/components/design/views/customizeOptions_GridGeneral.html'
    }, {
        name: 'THEME', // 21
        templateUrl: 'js/app/components/design/views/customizeOptions_ThemeHighcharts.html'
    }, {
        name: 'GENERAL', // 22
        //templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_general.html'
        templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_generalV3.html'
    }, {
        name: 'APPEARANCE', // 23
        //templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_appearance.html'
        templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_appearanceV3.html'
    }, {
        name: 'LABEL', // 24
        //templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_label.html'
        templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_labelV3.html'
    }, {
        name: 'DATA_SERIES', // 25
        templateUrl: 'js/app/components/design/views/customizeOptions_dfaDotMatrix_dataSeries.html'
    }
    ])
    .constant('TIME_PERIODS', {
        "": "Linked to Global Filter",
        "MRD1": "Most Recent Data",
        "MRD2": "Time Series (last 2 time periods)",
        "MRD3": "Time Series (last 3 time periods)",
        "MRD4": "Time Series (last 4 time periods)",
        "MRD5": "Time Series (last 5 time periods)",
        "MRD6": "Time Series (last 6 time periods)",
        "MRD7": "Time Series (last 7 time periods)",
        "MRD8": "Time Series (last 8 time periods)",
        "MRD9": "Time Series (last 9 time periods)",
        "MRD10": "Time Series (last 10 time periods)",
        "MRD11": "Time Series (last 11 time periods)",
        "MRD12": "Time Series (last 12 time periods)",
        "All": "Time Series (all time periods)"
    })

    .constant('FILTERS_TIME_PERIODS', {
        "MRD4": "TIME_SERIES_4_TP",
        "MRD5": "TIME_SERIES_5_TP",
        "MRD6": "TIME_SERIES_6_TP",
        "MRD7": "TIME_SERIES_7_TP",
        "MRD8": "TIME_SERIES_8_TP",
        "MRD9": "TIME_SERIES_9_TP",
        "MRD10": "TIME_SERIES_10_TP",
        "MRD11": "TIME_SERIES_11_TP",
        "MRD12": "TIME_SERIES_12_TP",
        "All": "TIME_SERIES_ALL_TP"
    })
    
    .constant('LINE_STYLE', {
        'Solid': 'SOLID',
        'ShortDash': 'SHORT_DASH',
        'ShortDot': 'SHORT_DOT',
        'ShortDashDot': 'SHORT_DASH_DOT',
        'ShortDashDotDot': 'SHORT_DASH_DOT_DOT',
        'Dot': 'DOT',
        'Dash': 'DASH',
        'LongDash': 'LONG_DASH',
        'DashDot': 'DASH_DOT',
        'LongDashDot': 'LONG_DASH_DOT',
        'LongDashDotDot': 'LONG_DASH_DOT_DOT'
    })
    .constant('SERIES_TYPE', {
        'line': 'LINE',
        'spline': 'SPLINE',
        'column': 'COLUMN',
        'area': 'AREA',
        'areaspline': 'AREA_SPLINE',
        'pie': 'PIE',
        'scatter': 'SCATTER'
    })
    .constant('SERIES_MARKER_SYMBOL', {
        'circle': 'CIRCLE',
        'square': 'SQUARE',
        'diamond': 'DIAMOND',
        'triangle': 'TRAINGLE'
    })
    .constant('DML_URL', 'https://dfadml.dataforall.org/')

    .constant('BREAK_TYPE', {
        'EQUAL_SIZE': "equalSize",
        'CUSTOM': "custom"
    })
    .constant('SELECT_LIST_TYPE', [
        'DROPDOWN', 'LIST_VIEW' //, 'TREE_VIEW'
    ])
    .constant('GLOBAL_SELECT_LIST_TYPE', [
        'DROPDOWN', 'LIST_VIEW' //, 'TREE_VIEW'
    ])
    .constant('GLOBAL_SELECT_LIST_DATA_TYPE', [
        'TIME_PERIOD', 'AREA'
    ])
    .constant('SELECT_LIST_DATA_TYPE', [
        // 'IC', 'IU', 'IUS', 'SUBGROUP', 'TIME_PERIOD', 'PERIODICITY', 'AREA'
        'IC', 'IU', 'SUBGROUP', 'TIME_PERIOD', 'AREA','GLOBAL_IU'
    ])
    .constant('TREEMAP_LEVELS', ['AREA', 'TIME_PERIOD', 'INDICATOR', 'UNIT', 'SUBGROUP']) //'IC'
    .constant('PROFILE_DOWNLOAD_OPTIONS', {
        'PDF': {
            'extension': "pdf"
        },
        'Excel': {
            'extension': "xlsx"
        }
    })
    .constant('SORT_ORDER', { 'asc': 'ASC', 'dsc': 'DSC', 'noOrder': 'PRESERVE_SEL_ORDER', 'dbOrder': 'PRESERVE_DB_ORDER' })
    .constant('DFA_TABLE_SORT_ORDER', { 'asc': 'ASC', 'desc': 'DSC' })
    .constant('GLOBAL_LIST_TIME_PERIODS', {
        "MRD2": "Time Series (last 2 time periods)",
        "MRD3": "Time Series (last 3 time periods)",
        "MRD4": "Time Series (last 4 time periods)",
        "MRD5": "Time Series (last 5 time periods)",
        "MRD6": "Time Series (last 6 time periods)",
        "MRD7": "Time Series (last 7 time periods)",
        "MRD8": "Time Series (last 8 time periods)",
        "MRD9": "Time Series (last 9 time periods)",
        "MRD10": "Time Series (last 10 time periods)",
        "MRD11": "Time Series (last 11 time periods)",
        "MRD12": "Time Series (last 12 time periods)",
        "All": "Time Series (all time periods)"
    })
    // .constant('GLOBAL_LIST_PERIODICITY', {
    //     "A": "Annually",
    //     "B": "Bi-Annually",
    //     "Q": "Quaterly",
    //     "M": "Monthly",
    //     "W": "Weekly",
    //     "D": "Daily",
    //     "O": "Other"
    // })
    // .constant('GLOBAL_LIST_PERIODICITY', {
    //     "": "All",
    //     "A": "Annually",
    //     "Q": "Quarterly",
    //     "M": "Monthly",
    //     "D": "Daily"
    // })
    .constant('GLOBAL_LIST_PERIODICITY', {
        "": "ALL",
        "A": "ANNUALLY",
        "Q": "QUARTERLY",
        "M": "MONTHLY",
        "D": "DAILY",
        "H": "HALF_YEARLY",
        "F": "FORTNIGHTLY"
    })
    .constant('GRID_CLASS_STYLE', [
        'ag-fresh',
        'ag-dark',
        'ag-blue',
        'ag-theme-material'
    ])
    .constant('GET_IND_AREA_TP_TAB', [
        'Select Indicator',
        'Select Area',
        'Select Time Period',
        'X-Axis & Y-Axis',
        'Grid',
        'Data Sorting',
        'Rows, Columns and Groupings'
    ])
    .constant('RANK_CHART_TYPE', {
        'children': 'Children',
        'sibling': 'Sibling'
    })
    .constant('AREA_OPTION_LIST', {
        'GLOBAL_SELECT_LIST': 'globalSelectList',
        'CHILDREN_OF_SELECTED_AREA': 'children',
        'PARENT_OF_SELECTED_AREA': 'parent',
        'SIBLING_OF_SELECTED_AREA': 'sibling',
        'CUSTOM_AREA': 'custom'
    })
    .constant('INDICATOR_EXCEPTION_TAB', {
        'SUBGROUP': 'subgroup',
        'IC': 'ic'
    })
    .constant('CURRENCY_FORMAT', {
        'en-IN': 'INR',
        'en-US': 'USD'
    })
    .constant('TOP_DOWN_OPTIONS', {
        'TOP': 'Topmost',
        'BOTTOM': 'Bottommost'
    })
    .constant('EMITTER_EVENTS', {
        "SINGLE_CLICK": "SINGLE_CLICK",
        "DOUBLE_CLICK": "DOUBLE_CLICK",
        "DRILLDOWN": "DRILLDOWN",
        "DRILLUP": "DRILLUP"
    })
    .constant('EMITTER_PARAMS', {
        "AREA": "area",
        "TIMEPERIOD": "tp",
        "SOURCE": "src",
        "IUS": "ius"
    })

        
    .constant('HEADER_FOOTER_SETTINGS',{
        'web_header':{
            'bgColor': '#990000',
            'height': 70,
            'borderBottom': {'color':'black','height': 2},
            'gapBottom':{'height':''},
            'logo1' : {'width' :'' ,'height' : '','filename':'','placeholder':''},
            'logo2' : {'width' : '','height' : '','filename':'','placeholder':''},
            'title1P1' : {'title' : 'Title','size' : 18,'color':'#fff','align':'left','verPosition':"top"},
            'title1P2' : {'title' : '','size' : 18,'color':'#fff','align':'left','verPosition':"top"},
            'title2' : {'title' : 'Subtitle','size' : 11,'color':'#fff','align':'left','verPosition':"middle"},
            'langSelColor':'#000'
            
        },
        'web_footer':{
            'bgColor': '#990000',
            'height' : 30,
            'borderTop': {'color':'black','height': 2},
            'logo1' : {'width' : '','height' : ''},
            'logo2' : {'width' : '','height' : ''},
            'caption1' : {'title' : 'Label-1','color':'#fff','size': 12,'align':'left','verPosition':"top"},
            'caption2' : {'title' : '','color':'#fff','size':12,'align':'left','verPosition':"top"},
            
        },
        'mobile_header':{
            'copytheme':false,
            'bgColor': '#990000',
            'height' : 60,
            'borderBottom': {'color':'black','height': 2},
            'gapBottom':{'height':''},
            'logo1' : {'width' : '','height' : ''},
            'logo2' : {'width' : '','height' : ''},
            'title1P1' : {'title' : 'Title','size' : 18,'color':'#fff','align':'left','verPosition':"top"},
            'title1P2' : {'title' : '','size' : 18,'color':'#fff','align':'left','verPosition':"top"},
            'title2' : {'title' : 'Subtitle','size' : 11,'color':'#fff','align':'left','verPosition':"middle"},
            'langSelColor':'#000'
        },
        'mobile_footer':{
            'bgColor': '#990000',
            'height' : '',
            'borderTop': {'color':'red','height': 2},
            'logo1' : {'width' : '','height' : ''},
            'logo2' : {'width' : '','height' : ''},
            'caption1' : {'title' : 'Label-1','color':'#fff','size': 14,'align':'left','verPosition':'top'},
            'caption2' : {'title' : 'Label-2','color':'#fff','size': 14,'align':'left','verPosition':'top'},
            
        },
        'favicon':'',
        'name':''
    })
    
    .constant('DEFAULT_VISUALIZATION_SETTINGS', {
        'numberFormat': {
            'locale': 'en-US',
            'precision': '2' 
        },
        'contentMenuOptions': {
            'LABELS': {
                "outsideMenu": false,
                "visibility": true
            },
            // 'EXPLORE': {
            //     "outsideMenu": false,
            //     "visibility": true
            // },
            'TABLE': {
                "outsideMenu": false,
                "visibility": true
            },
            'DOWNLOAD_AND_SHARE': {
                "outsideMenu": false,
                "visibility": true
            },
            'SORT': {
                "outsideMenu": false,
                "visibility": true
            },
            'CHANGE_CHART_TYPE': {
                "outsideMenu": false,
                "visibility": true
            },
            'FULL_VIEW': {
                "outsideMenu": false,
                "visibility": true
            },
            // 'SHARE_AND_EMBED': {
            //     "outsideMenu": true,
            //     "visibility": true
            // },
            'MAP_SPECIFIC': {
                "outsideMenu": false,
                "visibility": true
            },
            'META_DATA' :{
                "outsideMenu": false,
                "visibility": true
            }
        },
        'dataValueFormatting': {},
        'filterOptions': {
            'IC': true,
            'IU':true,
            'SUBGROUP':true,
            'TIMEPERIOD':true
        }
    })
    .constant('LOCALE_OPTIONS', [
        'ar-SA', 'bn-BD', 'en-IN', 'bn-IN', 'en-US', 'en-NZ', 'en-GB'
    ])
    .constant('EXTERNAL_API_SOURCE', {
        'AASMAN': 'Aasman'
    })
    .constant('RTL_LANGUAGES', [
        'ps', 'dr', 'ar'
    ])
    .constant('DOT_DENSITY_MAP_IUS_OPTION', ['SINGLE', 'HYBRID_MAP', 'UNIT_BASED'])
    .constant('TOP_BOTTOM_OPTIONS', ['BOTTOM', 'TOP'])
    .constant('ERROR_CODE', {
        'DFAERR213': 'Password must contain atleast one special character(&@#$), minimum length 8, atleast one upper and one lower case letter and one numeric character.'
    })
    .constant('DFAERR110','Incorrect Password.')
    .constant('CONST_TITLE_DYINA_OPTIONS', {
        'IND':'{{I}}', 
        'UNIT':'{{U}}', 
        'SUB':'{{S}}', 
        'AREA':'{{A}}',
        'TIME': '{{T}}'
    })
    .constant('CONST_TILES_DYINA_OPTIONS', {
        'IND':'{{VODYN:0:LIST-IND}}', 
        'UNIT':'{{VODYN:0:LIST-UNIT}}', 
        'SUB':'{{VODYN:0:LIST-SUBGROUP}}', 
        'AREA':'{{VODYN:0:LIST-AREA}}',
        'TIME': '{{VODYN:0:TP}}',
        'SRC': '{{VODYN:0:SRC}}',
        'DATA': '{{VODYN:0:DVNUM:0}}'
    })
    .constant('LABEL_FORMATTER', {
        // "LBL_UNIT_DV": [ // Unit based formatting at Global level 
        //     "{y}",
        //     "{y:.0f}",
        //     "{y:.1f}",
        //     "{y:.2f}",
        //     "prefix{y:.0f}suffix"
        // ],
        // "VIZ_XYAXIS": [ // Unit based formatting at Global level 
        //     "{value}",
        //     "{value:.0f}",
        //     "{value:.1f}",
        //     "{value:.2f}",
        //     "{value:,.0f}",
        //     "{value:%Y-%m-%d}",
        //     "prefix{value:.0f}suffix"
        // ]
        "LBL_UNIT_DV": [ // Unit based formatting at Global level 
            {"key": "none", "value":"{y}"},
            {"key": "0", "value": "{y:.0f}"},
            {"key": "0.0", "value": "{y:.1f}"},
            {"key": "0.00", "value": "{y:.2f}"},
            {"key": "0,000", "value": "{y:,.0f}"}
        ],        
        "VIZ_XYAXIS": [ // Unit based formatting at Global level 
            {"key": "none", "value": "{value}"},
            {"key": "0", "value": "{value:.0f}"},
            {"key": "0.0", "value": "{value:.1f}"},
            {"key": "0.00", "value": "{value:.2f}"},
            {"key": "0,000", "value": "{value:,.0f}"},
            {"key": "yyyy-mm-dd", "value": "{value:%Y-%m-%d}"}
        ]
    })
    /**
     * Constant for visualization properties
     * When you create a visualization, these properies should be set by default
     * for example x-axis ticks, should be checked by default since highcharts renders the vis with enabled ticks in x-axis
     */
    .constant('VIZ_DEF_PROPERTIES_OBJ', {
        datacubeinfo: {
            selectedTimePeriod: "",
            exceptionTimePeriod: ""
        },
        properties: {
            Ttl: {},
            SbTtl: {},
            Lbl: {},
            areaSelectionType: 'globalSelectList',
            RnkCht: {
                ChildIncSelAr: false
            },
            XAxTtl: {},
            YAxTtl: {},
            XAxLblEnb: true,
            YAxLblEnb: true,
            LegEnb: true,
            XAxFmt: "{value}",
            YAxFmt: {}, //"{value}",
            YAxSecFmt: {},
            XAxFntSz: "10",
            XAxLblClr: '',
            XAxLblFntSty: '',
            XAxLblFntSz: '10',
            XAxLblFntWgt: '',
            YAxFntSz: "10",
            YAxLblClr: '',
            YAxLblFntSty: '',
            YAxLblFntSz: '10',
            YAxLblFntWgt: '',
            XAxGrdLnDshSty: "ShortDash",
            YAxGrdLnDshSty: "ShortDash",
            XAxGrdLnClr: '#dfdfdf',
            YAxGrdLnClr: '#dfdfdf',
            HgtBorderClr: '#dfdfdf',
            LegHorAlg: '',
            LegVAlign: '',
            sortOrder: '',
            mediaFiles: {},
            DtLblFmt: {},
            XAxTickWdth: 1,
            YAxGrdLnWdth: 1,
            XAxGrdLnWdth: 0,
            EnbConnector:true,
            fntCategory:'',
            tableObj:{
                rows:[],
                column:''
            },
            tableProperties:{
                tableTemplate:'display',
                TableHeaderFntWgt:'bold',
                TablegroupingHeaderFntWgt:'bold'
            },
            
        },
        provider: 'highcharts',
        typecategory: 'columnbar',
        type: 'groupedcolumn',
        isused: false
    })
    /**
     * Default properties object for select list
     */
    .constant('SL_DEF_PROPERTIES_OBJ', {
        datacubeinfo: {},
        properties: {},
        provider: 'selectList',
        typecategory: '',
        type: '',
        isused: false
    })
    /**
     * Default Seetings for Custom Tile
     */
    .constant('CUSTOM_TILE_SETTINGS', {
        tileStyles: { // Tile Images
            "1": [ // Theme 1
                "tile_style_1_1",
                "tile_style_1_2",
                "tile_style_1_3",
                "tile_style_1_4",
                "tile_style_1_5",
                "tile_style_1_6"
            ],
            "2": [ // Theme 2
                "tile_style_2_1",
                "tile_style_2_2"
            ]
        },        
        tileHtmls: {
            "tile_style_1_1": '<div class="customTileTheme1 tile1" style="{{_TBG1BRD_}}">\
                                <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                <div class="bottomBx" style="{{_TBG2_}}">\
                                    <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                    <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                </div>\
                              </div>',
            "tile_style_1_2": '<div class="customTileTheme1 tile2" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="bottomBx" style="{{_TBG2_}}">\
                                        <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                        <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                    </div>\
                                </div>',
            "tile_style_1_3": '<div class="customTileTheme1 tile3" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="bottomBx" style="{{_TBG2_}}">\
                                        <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                        <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                    </div>\
                                </div>',
            "tile_style_1_4": '<div class="customTileTheme1 tile4" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="bottomBx" style="{{_TBG2_}}">\
                                        <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                        <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                    </div>\
                                </div>',
            "tile_style_1_5": '<div class="customTileTheme1 tile5" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="bottomBx" style="{{_TBG2_}}">\
                                        <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                        <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                    </div>\
                                </div>',
            "tile_style_1_6": '<div class="customTileTheme1 tile6" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="bottomBx" style="{{_TBG2_}}">\
                                        <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                        <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                    </div>\
                                </div>',
            "tile_style_2_1": '<div class="customTileTheme2 tile7" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                    <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                </div>',
            "tile_style_2_2": '<div class="customTileTheme2 tile8" style="{{_TBG1BRD_}}">\
                                    <div class="imgContainer" style="{{_TICONALST_}}"><img src="{{_TICONSRC_}}" alt="" style="{{_TICONSTY_}}"></div>\
                                    <div class="label1" style="{{_TLBL1STY_}}">{{_TLBL1_}}</div>\
                                    <div class="label2" style="{{_TLBL2STY_}}">{{_TLBL2_}}</div>\
                                    <div class="label3" style="{{_TLBL3STY_}}">{{_TLBL3_}}</div>\
                                    <div class="label4" style="{{_TLBL4STY_}}">{{_TLBL4_}}</div>\
                                    <div class="label5" style="{{_TLBL5STY_}}">{{_TLBL5_}}</div>\
                                </div>'

        },
        tileDefProp: {
            "DEFAULT": {
                "theme": "", // theme name/id 
                "bg": ["#DADADA", "#C7C7C7"], // background color 1 & 2
                "bdr": ["", "0", "0"], // border color, width and radius
                "lblTxt": {
                    "lbl1": {}, // label 1 text
                    "lbl2": {}, // lable 2 text
                    "lbl3": {}, // lable 3 text
                    "lbl4": {}, // lable 4 text
                    "lbl5": {} // lable 5 text
                },
                "lblDyn": [false, false, false, false, false], // dynamic for Label 1, 2, 3, 4 and 5
                "lblFnt": ["inherit", "inherit", "inherit", "inherit", "inherit"], // fornt family for Label 1, 2, 3, 4 and 5
                "lblClr": ["#605e5e", "#605e5e", "#605e5e", "#605e5e", "#605e5e"], // fornt color for Label 1, 2, 3, 4 and 5
                "lblSze": ["10", "14", "10", "12", "12"], // fornt size for Label 1, 2, 3, 4 and 5
                "lblWght": ['normal', 'bold', 'normal', 'normal', 'normal'], // label font weight label 1, 2, 3, 4 and 5
                "lblItal": ['normal', 'normal', 'normal', 'normal', 'normal'], // label font italic for label 1, 2, 3, 4 and 5
                "lblUnder": ['none', 'none', 'none', 'none', 'none'], // label font underline for label 1, 2, 3, 4 and 5
                "lblAlign": ["center", "center", "center", "left", "right"], // label alignment for label 1, 2, 3, 4 and 5
                "icon": {
                    "show": true,
                    "media": "", // media value - media placeholder
                    "widh": "",
                    "hght": "",
                    "algn": "left", // image align
                    "bgc": "", // background color
                    "bdrc": "", // border color
                    "bdrw": "", // border width
                    "bdrr": "", // border radius
                }
            }
        },
        /**
         * Default Properties for custom Text, settings will be appiled by default
         */
        textDefProp: {
            "DEFAULT": {
                "bg": "",
                "bdr": ["", "0", "0"], // Border color, width and radius
                "font": [
                    "inherit", // 0 - font family
                    "", // 1 - font color
                    "", // 2 - font size,
                    "normal", // 3 - font bold
                    "normal", // 4 - font italic
                    "none", // 5 - font underline
                    "left" // 6 - alignment
                ]
            }
        },
        /**
         * Default Properties for custom Image, settings will be appiled by default
         */
        imgDefProp: {
            "DEFAULT": {
                "mode": "media", // media or url
                "fn": "", // media file name or url
                "wh": ["100", "100", "%"], // Image width, height and percent or px
                "bdr": ["", "", ""], // Border color, width and radius
                "bgc": "",
                "align": ""// image alignment
            }
        },
        /**
         * Default Properties for custom Video, settings will be appiled by default
         */
        videoDefProp: {
            "DEFAULT": {
                "mode": "media", // media or url
                "fn": "", // media file name or url
                "wh": ["100", "100", "%"], // Video width, height and percent or px
                "bdr": ["", "", ""], // Border color, width and radius
                "bgc": "",
                "align": ""// Video alignment
            }
        },
    })
    /**
     * Default Seetings map where no data and area to be clicked
     */
    .constant('MAP_DEF_MISSING_DATA', {
        fakeValue: -9999999,
        colorCode: '#f7f7f7'
    })

    .constant('DT_FIELDS',{
        'DFA_IND':'INDICATOR', 
        'DFA_UNIT':'UNIT', 
        'DFA_SUB':'SUBGROUP', 
        'DFA_AREA':'AREA',
        'DFA_AREAID':'PROFILE_AREAID',
        'DFA_TIME': 'TIME_PERIOD',
    })
    .constant('DT_TEMPLATE',['display','cell-border','compact','hover','nowrap','order-column','row-border','stripe'])

    .constant('CAT_SUBGROUP_SORT_OPTIONS', {
        "ALPHA_ASC": "ALPHABATIC_ASC",
        "ALPHA_DESC": "ALPHABATIC_DESC",
        "DB_ASC": "DATABASE_ASC",
        "DB_DESC": "DATABASE_DESC",
        "DV_ASC": "DATAVALUE_ASC",
        "DV_DESC": "DATAVALUE_DESC",
        "MAN": "MANUAL",
    })

    .constant('CAT_SUBGROUP_SORT_OPTIONS_DV', {
        "DV_ASC": "DATAVALUE_ASC",
        "DV_DESC": "DATAVALUE_DESC"
    })

    .constant('MAP_DATA_LABEL_FORMAT', {
        "an": "Area Name",
        "andv": "Area Name (Data Value)",
        "dv": "Data Value"
    })